





















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import tippy from 'tippy.js';

@Component
export default class PageNav extends Vue {

  @Prop({ default: 0,  type: Number}) numPages!: number;
  
  curPage = 0;

  mounted() {
    tippy('[data-tippy-content]');
  }
  
  pageUpdate(index:number) {
    this.curPage = index;
    this.$emit('page-change', index);
  }

  shouldRender(index:number):boolean {
    // we return the items available in between
    return Math.abs(index - this.curPage) <= 2;
  }
  
  public reset() {
    this.curPage = 0;
  }
}

